import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { url } from "../../baseUrl.js";

export const fetchAvailableSlots = createAsyncThunk(
  "availableSlots/fetchAvailableSlots",
  async (filters, thunkAPI) => {
    try {
      // Удаляем пустые значения
      const cleaned = {};
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== "") {
          cleaned[key] = value;
        }
      });

      const query = new URLSearchParams(cleaned).toString();

      const { data } = await axios.get(
        `${url}/api/public/available-slots?${query}`
      );
      // console.log(data);
      // console.log("[fetchAvailableSlots] ✅ received data:", data);
      return data;
    } catch (err) {
      // console.error("[fetchAvailableSlots] ❌ ERROR:", err);
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch slots"
      );
    }
  }
);
